import type { Namespace } from 'i18next';

export const getOptions = (lang = 'en', ns: Namespace = []) => ({
	lng: undefined, // detection doesn't work if using lng https://github.com/i18next/i18next/blob/ee3afd8e5d958e8d703a208194e59fa5228165fd/src/i18next.js#L189
	preload: ['en', 'vi', 'tr', 'pt', 'id', 'hi', 'es'], // to avoid flicker. when default language is ja and user language is en
	fallbackLng: lang,
	supportedLngs: ['en', 'vi', 'tr', 'pt', 'id', 'hi', 'es'],
	ns: Array.isArray(ns) ? ['common', ...ns] : ['common'],
	detection: {
		order: ['cookie', 'navigator'],
		lookupCookie: 'infora_i18next',
		caches: ['cookie'],
		convertDetectedLanguage: (lng: string) => lng.replace('-', '_'),
	},
	interpolation: {
		escapeValue: false,
	},
});
